"use client";
import React from "react";

const CustomCard = ({
  title,
  tenyearvalue,
  fiveyearvalue,
  threeyearvalue,
  oneyearvalue,
  ttmvalue,
}) => {
  return (
    <div className="border border-solid border-[#d9d9d9] w-[191px] h-[167px] rounded-lg p-4">
      <p className="text-sm font-semibold text-[#333333] whitespace-nowrap overflow-hidden text-ellipsis">
        {title}
      </p>
      <div className="flex justify-between mt-3">
        <p className="text-xs font-bold text-[#8B8B8B]">10 years</p>
        <p className="font-semibold text-sm text-[#262626]">{tenyearvalue}</p>
      </div>
      <div className="flex justify-between mt-3">
        <p className="text-xs font-bold text-[#8B8B8B]">5 years</p>
        <p className="font-semibold text-sm text-[#262626]">{fiveyearvalue}</p>
      </div>{" "}
      <div className="flex justify-between mt-3">
        <p className="text-xs font-bold text-[#8B8B8B]">3 years</p>
        <p className="font-semibold text-sm text-[#262626]">{threeyearvalue}</p>
      </div>
      {oneyearvalue ? (
        <div className="flex justify-between mt-3">
          <p className="text-xs font-bold text-[#8B8B8B]">1 year</p>
          <p className="font-semibold text-sm text-[#262626]">{oneyearvalue}</p>
        </div>
      ) : null}
      {ttmvalue ? (
        <p className="font-semibold text-xs text-right mt-3 text-[#8B8B8B]">
          TTM:<span className="text-[#262626]">{ttmvalue}</span>
        </p>
      ) : null}
    </div>
  );
};

export default CustomCard;
